import { useMemo } from "react";
import { useDispatch, useStore } from "react-redux";
import { RouteProps } from "react-router-dom";
import { FxGuard } from "@coralblack/flax";
import { preparedCallbackLink } from "@pages/auth/SSO";
import { UserFlax } from "@maven-rest/sso/User.flax";
import { configurableDefaultHeaders, RootState, sessionSlice } from "@maven-rest/states";
import { getDefaultHostname } from "@sso-lib/host";

interface ProtectedRouteProps extends RouteProps {}

export function RedirectPage(props: ProtectedRouteProps) {
  const session = useStore<RootState>().getState().session;

  const dispatch = useDispatch();
  const { redirectHostname } = useMemo(
    () =>
      getDefaultHostname({
        from: process.env.REACT_APP_SERVICE_SSO_FE_DOMAIN_FROM || "",
        to: process.env.REACT_APP_SERVICE_SSO_FE_DOMAIN_TO || "",
        defaultVal: process.env.REACT_APP_AUTH_FE_URL!,
        hostname: window.location.hostname,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [process.env.REACT_APP_SERVICE_SSO_FE_DOMAIN_FROM, process.env.REACT_APP_SERVICE_SSO_FE_DOMAIN_TO, process.env.REACT_APP_AUTH_FE_URL]
  );
  const defaultRedirect = `${redirectHostname.startsWith("http") ? "" : `${window.location.protocol}//`}${redirectHostname}`;

  return (
    <FxGuard
      key="static"
      api={{ ...UserFlax.getMyInfo({}), headers: configurableDefaultHeaders() }}
      loading={() => <div className="app-spinner" />}
      render={(resp) => {
        if (resp) {
          document.location.href = preparedCallbackLink(session) || defaultRedirect;
          return <></>;
        }

        return;
      }}
      error={(err) => {
        if (err?.code === "CREDENTIAL-INVALID") {
          dispatch(sessionSlice.actions.signOut());

          return <></>;
        }

        return (
          <>
            [{err?.code || "UNKNOWN"}] {err?.message || "An error has occurred."}
          </>
        );
      }}
    />
  );
}
